import { render, staticRenderFns } from "./ShopSkinDtEditComponent.vue?vue&type=template&id=6864abbc&scoped=true"
import script from "./ShopSkinDtEditComponent.vue?vue&type=script&lang=js"
export * from "./ShopSkinDtEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopSkinDtEditComponent.vue?vue&type=style&index=0&id=6864abbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864abbc",
  null
  
)

export default component.exports